const ro = {
    'Management of work points': 'Administrează puncte de lucru',
    'Add work point': 'Adaugă punct de lucru',
    Location: 'Locație',
    'Edit work point': 'Editează punct de lucru',
    'The work point was successfully deleted!': 'Punctul de lucru a fost șters cu succes!',
    'Something went wrong!': 'Ceva n-a mers bine!',
    'The work point has been updated successfully!': 'Punctul de lucru a fost actualizat cu succes!',
    'Work point has been added successfully!': 'Punctul de lucru a fost adăugat cu succes!',
    'Are you sure you want to delete this work point?': 'Sigur doriți să ștergeți acest punct de lucru?',
    'Something went wrong! This workpoint could not be deleted!':
        'Ceva n-a mers bine! Acest punct de lucru nu a putut fi șters!',
    'There is already a work point with this name!': 'Există deja un punct de lucru cu acest nume!',
    'The locality is mandatory!': 'Locația este obligatorie!',
    'You do not have access to any action!': 'Nu aveți acces la nicio acțiune!',
};

export default { ro };
